import React from 'react';

export default ({ open }) => {
    return (
        !open ? '' :
            <div className="loading"></div>
    );
}